<template>
  <div class="container">
    <div class="login-container">
      <div class="left">
        <img src="./login.svg" class="img" />
      </div>
      <div class="right">
        <p class="title">SIGN IN.</p>
        <el-form ref="ff" class="login-form" :model="formdata">
          <el-form-item title="用户名" prop="account" required>
            <el-input v-model="formdata.account" placeholder="用户名" clearable> </el-input>
          </el-form-item>
          <el-form-item title="密码" prop="password" required>
            <el-input type="password" v-model="formdata.password" placeholder="密码" clearable />
          </el-form-item>
          <el-form-item title="验证码" prop="captcha" required>
            <el-input v-model="formdata.captcha" placeholder="验证码" clearable>
              <img :src="captcha" class="ccf" style="height: 40px; cursor: pointer" slot="append" title="看不清？点击切换" @click="getCaptcha" />
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-loading="loading" @click="onLogin" @keyup.enter="onEnter">登录 Enter</el-button>
            <el-checkbox v-model="formdata.hold" label="记住我" style="margin-left: 30px" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="footer">
      <span>Copyright ©2021~2022 昆明莱尔电气自动化系统有限责任公司 All Right Reserve.</span>
      <a href="http://beian.miit.gov.cn/" target="_blank">滇ICP备16000466号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      loading: false,
      captcha: null,
      formdata: JSON.parse(localStorage.getItem("hold") ?? "{}")
    }
  },
  created () {
    this.getCaptcha()
    this.onEnter() //触发回车

    //清空缓存
    this.$utils.cookies.remove("token")
    this.$utils.cookies.remove("refresh_token")
    // localStorage.removeItem("user")
    localStorage.clear()

    //阻止回退
    history.pushState(null, null, document.URL)
    window.addEventListener(
      'popstate',
      function () {
        history.pushState(null, null, document.URL)
      },
      false
    )
  },
  methods: {
    //验证码
    getCaptcha () {
      this.$apis.system.auth.captchaImage().then((res) => {
        this.captcha = "data:image/gif;base64," + res
      })
    },
    //回车
    onEnter () {
      document.onkeydown = (e) => {
        if (e.keyCode === 13) {
          //13表示回车键
          this.onLogin()
        }
      }
    },
    onLogin () {
      this.$refs["ff"].validate((valid) => {
        if (valid && !this.loading) {
          this.loading = true
          this.$apis.system.auth.login(this.formdata).then(res => {
            //数据缓存
            if (this.formdata.hold) {
              localStorage.setItem(
                "hold",
                JSON.stringify({
                  account: this.formdata.account,
                  hold: this.formdata.hold,
                })
              )
            } else {
              localStorage.removeItem("hold")
            }
            localStorage.setItem("user", JSON.stringify(res["UserInfo"]))
            this.$utils.cookies.set("token", res["Tokens"]["accessToken"])
            this.$utils.cookies.set("refresh_token", res["Tokens"]["refreshToken"])
          }).then(() => {
            this.$router.push({
              path: this.$route.query.redirect || '/console',
            })
          }).catch((e) => {
            this.$message.error(e || "执行错误")
            this.getCaptcha()
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
  },
}
</script>


<style lang="scss" scoped>
.container {
  min-width: 100%;
  height: 100%;
  display: inline-flex;
  flex-direction: column;
  background-color: #2c3643;
  background-image: url('./bg.svg');
  background-size: cover;
  background-position: center;
}
.login-container {
  flex: 1;
  display: grid;
  min-width: 800px;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px 20px;
  margin: 50px 12%;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .left {
    padding: 5%;
    position: relative;
    .title {
      font-size: 24px;
      color: #3787ea;
    }
    .img {
      display: block;
      min-width: 300px;
      height: 80%;
      position: absolute;
      top: 10%;
      right: 10%;
    }
  }
  .right {
    min-width: 360px;
    padding-right: 15%;
    padding-top: 30px;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    .title {
      font-size: 72px;
      color: #ccc;
      font-weight: bold;
      margin-bottom: 30px;
    }
    .login-form {
      max-width: 360px;
    }
  }
}
.footer {
  color: #999;
  text-align: center;
  line-height: 40px;
  a {
    margin-left: 30px;
  }
}
:deep(.el-input__inner) {
  background-color: unset;
  border: none;
  border-bottom: 1px solid #dcdfe6;
  border-radius: 0;
  font-size: 20px;
  height: 64px;
  line-height: 64px;
  padding-left: 0;
}
:deep(.el-form-item) {
  min-height: 72px;
}
:deep(.el-input-group__append),
:deep(.el-input-group__prepend) {
  background-color: unset;
  border: none;
  border-bottom: 1px solid #dcdfe6;
  border-radius: 0;
  padding: 0;
}
</style>